// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1XC8R","colCheckbox":"styles_colCheckbox__Dvi2C"};